import { useBookSearchRefinements } from '@hermes/search'
import { TranslationKey } from '@hermes/translations'
import { Box, Chip, CloseIcon, useTheme } from '@hermes/web-components'

import useTranslateMessage from '@hooks/useTranslateMessage'

const RemoveAllRefinementsButton = () => {
  const { resetRefinements } = useBookSearchRefinements()

  const { t } = useTranslateMessage()
  return (
    <Chip
      size={'medium'}
      key={'index'}
      label={t({ id: 'remove.all', defaultMessage: 'Remove all' })}
      onClick={() => {
        resetRefinements()
      }}
      variant={'outlined'}
      color={'error'}
      sx={{ marginBottom: '6px', fontWeight: '500' }}
    ></Chip>
  )
}

export const CurrentRefinements = () => {
  const { activeRefinements, toggleRefinement: refine } = useBookSearchRefinements()

  const { t } = useTranslateMessage()
  const theme = useTheme()
  const { up } = theme.breakpoints
  const activeAttributesRefined = Array.from(activeRefinements.values()).map((facet) => facet.attribute)
  return (
    <Box sx={{ [up('md')]: { minHeight: '40px' } }}>
      {Array.from(activeRefinements).map((refinement) => (
        <Chip
          size={'medium'}
          key={refinement.value}
          label={`${t({
            id: (refinement.attribute === 'genres.code'
              ? `genre.thema.${refinement.value}`
              : `${refinement.value}`) as TranslationKey,
            defaultMessage: t({ id: refinement.attribute as TranslationKey, defaultMessage: refinement.value })
          })}`}
          onDelete={() => refine(refinement)}
          variant="outlined"
          sx={{ marginRight: '10px', marginBottom: '6px', maxWidth: '100%', fontWeight: '450', fontSize: '12' }}
          deleteIcon={<CloseIcon width="18px" style={{ marginLeft: '6px' }} />}
        ></Chip>
      ))}
      {activeAttributesRefined.length > 0 && <RemoveAllRefinementsButton />}
    </Box>
  )
}
